import React, { ReactNode } from 'react';
import { Col, Row, Typography } from 'antd';
import { BaseType } from 'antd/es/typography/Base';

type DeliveryAttributeProps = {
  attributeValue: ReactNode | string;
  attributeIcon?: ReactNode | string;
  textType?: BaseType;
  isTitle?: boolean;
};

const DeliveryAttribute = ({
  attributeIcon,
  attributeValue,
  textType,
  isTitle = false
}: DeliveryAttributeProps): JSX.Element => {
  const isRawValue = typeof attributeValue === 'string';
  const TextContainer = isTitle ? Typography.Title : Typography.Text;

  return (
    <Row style={{ marginBottom: 8, flexWrap: 'nowrap' }}>
      {attributeIcon && <Col style={{ minWidth: 24 }}>{attributeIcon}</Col>}
      <Col flex={1}>
        {isRawValue ? (
          <TextContainer level={4} type={textType}>
            {attributeValue}
          </TextContainer>
        ) : (
          attributeValue
        )}
      </Col>
    </Row>
  );
};

export default DeliveryAttribute;
